import { ResponseMiddleware } from "@/shared/utils/http-client";


export const refreshMiddleware = (
    refreshToken: () => Promise<string | null>,
    onSessionExpired: () => void
): ResponseMiddleware => {
    let refreshing: Promise<string | null> | null = null;

    return async (ctx, next) => {
        const result = await next(ctx);

        if (result.response.status !== 401 || ctx.request.isRetry) return result;

        if (!refreshing)
            refreshing = refreshToken().finally(() => { refreshing = null; });

        const token = await refreshing.catch(() => null);
        if (!token) {
            onSessionExpired();
            return result;
        }

        const headers = new Headers(ctx.request.headers);
        headers.set('Authorization', `Bearer ${token}`)

        const retryRequest = Object.assign(
            new Request(ctx.request, { headers }),
            { isRetry: true }
        );

        return { 
            request: retryRequest, 
            response: await fetch(retryRequest) 
        };
    }
}